import React from 'react';
import clsx from 'clsx';
import { TableCell } from '@material-ui/core';
import ArrowUpIcon from '../icons/ArrowUpIcon';
import ArrowDownIcon from '../icons/ArrowDownIcon';

interface Props {
  label: string | React.ReactNode;
  order: 'asc' | 'desc' | 'class' | 'ppi' | undefined;
  onClick: () => void;
  tableHeadCellClassName?: string;
  orderIconClassName?: string;
  orderIconActiveClassName?: string;
}

export const SortableTableHeaderCell: React.FC<Props> = ({
  label,
  order,
  onClick,
  tableHeadCellClassName = '',
  orderIconClassName = '',
  orderIconActiveClassName = '',
}) => {
  return (
    <TableCell
      className={tableHeadCellClassName}
      align="center"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <div style={{ display: 'inline-flex', alignItems: 'center' }}>
        <span>{label}</span>
        {order === 'asc' ? (
          <ArrowUpIcon
            className={`${orderIconClassName} ${orderIconActiveClassName}`}
          />
        ) : (
          <ArrowDownIcon
            className={`${orderIconClassName} ${order ? orderIconActiveClassName : ''}`}
          />
        )}
      </div>
    </TableCell>
  );
};
